import React from 'react';
import Icon from './Icon';

interface Props {
  feedback: string; // '' | 'liked' | 'disliked'
  onThumbsUp: () => void;
  onThumbsDown: () => void;
  disabled?: boolean;
}

// Thumbs up/down on a recipe tile -- independent of the heart "save to My
// Recipes" button. Liked is just a recorded preference (no other effect
// yet); disliked keeps the recipe out of future AI suggestions.
const FeedbackButtons: React.FC<Props> = ({ feedback, onThumbsUp, onThumbsDown, disabled }) => (
  <div className="feedback-btns">
    <button
      type="button"
      className={`feedback-btn thumbs-up ${feedback === 'liked' ? 'active' : ''}`}
      onClick={onThumbsUp}
      disabled={disabled}
      aria-label={feedback === 'liked' ? 'Remove like' : 'Like this recipe'}
      aria-pressed={feedback === 'liked'}
    >
      <Icon name="thumbs-up" className="icon icon-sm" />
    </button>
    <button
      type="button"
      className={`feedback-btn thumbs-down ${feedback === 'disliked' ? 'active' : ''}`}
      onClick={onThumbsDown}
      disabled={disabled}
      aria-label="Dislike this recipe"
      aria-pressed={feedback === 'disliked'}
    >
      <Icon name="thumbs-down" className="icon icon-sm" />
    </button>
  </div>
);

export default FeedbackButtons;
